import Vue from "vue";
import LibMsgBoxVue from "./LibMsgBox.vue";

let instance;
const LibMsgBoxConstructor = Vue.extend(LibMsgBoxVue);
const initInstance = (options) => {
  instance = new LibMsgBoxConstructor({
    title: "提示",
    message: "这是一条消息",
    type: "warning",
    showClose: false,
    distinguishCancelAndClose: false,
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: "取 消",
    confirmButtonText: "确 定",
    closeOnClickModal: false,
    closeOnPressEscape: false,
    dangerouslyUseHTMLString: false, // 是否支持html格式
    ...options,
  });
};

const LibMsgBox = (options) => {
  return new Promise((resolve, reject) => {
    const instanceHasBeenInit = !!instance;
    const instanceStillExistOnDocument = !!document.querySelector(".lib-msg-box");
    if (instanceHasBeenInit && instanceStillExistOnDocument) {
      instance.show = true;
      for (let key in options) {
        instance[key] = options[key];
      }
    } else {
      initInstance(options);
      instance.$mount();
      document.getElementsByTagName("body")[0].appendChild(instance.$el);
      Vue.nextTick(function () {
        instance.show = true;
      });
    }
    instance.cancel = () => {
      instance.show = false;
      reject("cancel");
    };
    instance.confirm = () => {
      instance.show = false;
      resolve("confirm");
    };
  });
};

["success", "warning", "info", "error"].forEach((type) => {
  LibMsgBox[type] = (options) => {
    if (typeof options === "object") {
      return LibMsgBox({
        ...options,
        type,
      });
    }
    if (typeof options === "string") {
      return LibMsgBox({
        type,
        message: options,
      });
    }
  };
});

export default LibMsgBox;

